import { el } from "./dom.js";

const VISIBLE_MS = 2600;

export class Toast {
  readonly root: HTMLElement;
  private hideTimer = 0;

  constructor() {
    this.root = el("div", { class: "toast hidden" });
  }

  show(message: string): void {
    this.root.textContent = message;
    this.root.classList.remove("hidden");
    this.root.classList.remove("playing");
    void this.root.offsetWidth;
    this.root.classList.add("playing");
    if (this.hideTimer) window.clearTimeout(this.hideTimer);
    this.hideTimer = window.setTimeout(() => {
      this.root.classList.add("hidden");
      this.hideTimer = 0;
    }, VISIBLE_MS);
  }

  destroy(): void {
    if (this.hideTimer) window.clearTimeout(this.hideTimer);
    this.hideTimer = 0;
    this.root.remove();
  }
}
